import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import TargetResultsBanner from "../Target/TargetResultsPage/TargetResultsBanner";
import TargetResultsCarousel from "../Target/TargetResultsPage/TargetResultsCarousel";
import { apiGetTargetProducts } from "Root/api/apiQuiz";
import RoundedGainfulButton from "Root/profile/components/common/RoundedGainfulButton";
import styles from "./styles.module.css";
import { useHistory } from "react-router-dom";
export const HyroxResults = () => {
    const hyroxData = JSON.parse(localStorage.getItem("hyroxResults") || "{}");
    const dataMap = {
        1: "protein_whey,boost_recover,flavor_cinnamon",
        2: "protein_whey,boost_recover,flavor_chocolate",
        3: "protein_plant,boost_recover,flavor_cinnamon",
        4: "protein_plant,boost_recover,flavor_chocolate",
    };
    const [products, setProducts] = useState([]);
    const getProducts = async () => {
        const product_string = dataMap[parseInt(hyroxData.option)];
        const data = await apiGetTargetProducts(product_string);
        setProducts(data);
    };
    const history = useHistory();
    const restart = () => {
        localStorage.removeItem("hyroxResults");
        history.push("/quiz-new/hyrox/");
    };
    useEffect(() => {
        getProducts();
    }, []);
    return (_jsxs(React.Fragment, { children: [_jsxs("div", { className: styles.hyroxresult, children: [_jsx("h1", { className: styles.hed, children: "You're all set" }), _jsx("hr", {}), _jsxs("div", { className: styles.resultsBox, children: [_jsxs("div", { className: styles.left, children: ["Blend #", hyroxData.option] }), _jsx("div", { className: styles.center, children: "\u2014with\u2014" }), _jsxs("div", { className: styles.right, children: [hyroxData.milk, " milk"] })] }), _jsxs("p", { className: styles.text, children: ["Let team Gainful know that you got ", _jsxs("b", { children: ["blend #", hyroxData.option] }), " with ", _jsxs("b", { children: [hyroxData.milk, " milk"] }), " and we'll get your shake mixed up ASAP."] }), _jsx(RoundedGainfulButton, { label: "Clear answers and restart", onClick: restart, extraClassName: styles.margin })] }), products && _jsx(TargetResultsBanner, { products: products }), products.length > 0 && _jsx(TargetResultsCarousel, { products: products, hideChange: true })] }));
};
